import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import i18next from 'i18next';
import SubscriptionDetails from '../../payments/subscriptionDetails';
import { Container, Tabs, Tab } from '@mui/material';

const t = (i18nKey, params) => i18next.t(`userDashboard.billing.subscription_choice.${i18nKey}`, params);
const features = i18next.t('userDashboard.billing.features', { returnObjects: true }); // This is super useful

function SubscriptionChoice() {
    const [visible, setVisible] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState(0);
    const [selectedSubscription, setSelectedSubscription] = useState({
        type: '',
        oldTotalCost: 0,
        newTotalCost: 0,
        discountAmount: 0,
    });
    const [isAnnual, setIsAnnual] = useState(true);

    const handleChooseSubscription = (type, oldTotalCost, newTotalCost, discountAmount) => {
        setSelectedSubscription({ type, oldTotalCost, newTotalCost, discountAmount });
        setVisible(true);
    };

    useEffect(() => {
        const paymentStatusParam = new URLSearchParams(location.search).get('payment_status');

        if (paymentStatusParam) {
            if (paymentStatusParam === '1') setPaymentStatus(1);
            else if (paymentStatusParam === '2') {
                setPaymentStatus(2);
                return;
            }
        } else return;
    }, []);

    return (
        <div className="tarifs-desktop">
            <div className="div-2">

                <Container className="columns is-justify-content-center">
                    <Tabs
                        value={isAnnual ? 'annuel' : 'mensuel'}
                        onChange={(event, newValue) => {
                            setIsAnnual(newValue === 'annuel');
                        }}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab label={t('monthly')} value="mensuel" />
                        <Tab label={<span>{t('annual')} <span style={{ color: 'red', marginLeft: '5px' }}>-20%</span></span>} value="annuel" />
                    </Tabs>
                </Container>

                <div className="overlap">
                    <div className="prices-section">
                        <div className="container is-widescreen">

                            <div className="columns m-1">
                                {/* DeepStart Card */}
                                <div className="column is-one-third">
                                    <div className="card has-text-centered full-height">
                                        <div className="card-content">
                                            <div style={{ minHeight: 350 }}>
                                                <div className="title">
                                                    <i className="fa fa-play" aria-hidden="true"></i>
                                                    <h2 className="title is-4 is-size-5-tablet is-size-3-desktop">DeepStart</h2>
                                                </div>
                                                <div className="price">
                                                    <h4 className="title is-1 pb-0 pt-1">{t('per_report_price')}</h4>
                                                </div>
                                            </div>
                                            <div className="option">
                                                <ul>
                                                    {features.deepStart.map((feature, index) => (
                                                        <li key={index}>
                                                            <i className="fa fa-check green-animation" aria-hidden="true"></i>
                                                            <span className="checkmark-text">{feature}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div>
                                            <a className="button is-primary">{t('subscribed')}</a>
                                        </div>
                                    </div>
                                </div>

                                {/* DeepPro Card */}
                                <div className="column is-one-third" onClick={() => handleChooseSubscription('DeepPro', isAnnual ? 4800 : 480, isAnnual ? 4800 : 480, isAnnual ? 800 : 0)}>
                                    <div className={clsx('card', 'has-text-centered', 'full-height', { 'is-annual': isAnnual })}>
                                        <div className="card-content">
                                            <div style={{ minHeight: 350 }}>
                                                <div className="title">
                                                    <i className="fa fa-star" aria-hidden="true"></i>
                                                    <h2 className="title is-4 is-size-5-tablet is-size-3-desktop">DeepPro</h2>
                                                </div>
                                                <div className="price">
                                                    <h4 className="title is-1 pb-0 pt-1">
                                                        {isAnnual ? t('annual_price') : t('monthly_price')}
                                                    </h4>
                                                    <p className="has-text-centered has-text-white is-italic is-size-4">
                                                        {isAnnual ? t('annual_offer') : t('first_month')}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="option">
                                                <ul>
                                                    {features.deepPro.map((feature, index) => (
                                                        <li key={index}>
                                                            <i className="fa fa-check green-animation" aria-hidden="true"></i>
                                                            <span className="checkmark-text">{feature}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div>
                                            <a className="button is-primary">{t('choose')}</a>
                                        </div>
                                    </div>
                                </div>

                                {/* DeepPro + Card */}
                                <div className="column is-one-third">
                                    <div className="card has-text-centered full-height">
                                        <div className="card-content">
                                            <div style={{ minHeight: 350 }}>
                                                <div className="title">
                                                    <i className="fa fa-crown" aria-hidden="true"></i>
                                                    <h2 className="title is-4 is-size-5-tablet is-size-3-desktop">DeepPro +</h2>
                                                </div>
                                                <div className="price">
                                                    <h4 className="title is-1 pb-0 pt-1">{t('contact_us')}</h4>
                                                </div>
                                            </div>
                                            <div className="option">
                                                <ul>
                                                    {features.deepProPlus.map((feature, index) => (
                                                        <li key={index}>
                                                            <i className="fa fa-check green-animation" aria-hidden="true"></i>
                                                            <span className="checkmark-text">{feature}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div>
                                            <a target="_blank" className="button is-primary" href='/contact'>{t('choose')}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr className="is-invisible" />
                    </div>
                </div>
            </div>

            <SubscriptionDetails
                visible={visible}
                onHide={() => setVisible(false)}
                subscriptionType={selectedSubscription.type}
                isAnnual={isAnnual}
                oldTotalCost={selectedSubscription.oldTotalCost}
                newTotalCost={selectedSubscription.newTotalCost}
                discountAmount={selectedSubscription.discountAmount}
                isLoading={false}
                setIsLoading={() => { }}
                paymentStatus={paymentStatus}
            />
        </div>
    );
}

export default SubscriptionChoice;